/* eslint-disable no-constant-condition */
import React, { FC, useContext, useEffect, useState } from "react";
import { FilterTransactionDetails, MerchantEx } from "../../models";
import "./../OutletsTable/OutletTable.scss";

import useComponentVisible from "../../CustomHooks/useComponentVisible";
import FilterMenu from "../../CustomComponent/FilterMenu/FilterMenu";
import Link from "../../CustomComponent/Link/Link";
import ReportCustomInput from "../../CustomComponent/CustomInput/CustomInput";
import Dropdown from "../../CustomComponent/DynamicDropDown/DynamicDropdown";
import { Spinner } from "react-bootstrap";
import ReTable from "../ReTable/ReTable";
import { Clock, OpenEyeIcon } from "../Icons/CheckOutLogo";
import ToolTip from "../../CustomComponent/Tooltip/Tooltip";
import useGetIntialDate from "../../CustomHooks/useGetIntialDate";
import {
  handleFormateCurrency,
  handleSoftposTransactionType,
} from "../commonFunctions";
import { useTranslation } from "react-i18next";
import ThemeContext from "../../ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { downloadTransactionsExcel } from "../../redux/actions/downloadTransactionsExcel";

interface TransTableProps {
  data?: {
    transactionListDetails: any;
    error: string | null;
    loading: boolean;
  };
  setFilterDetails?: ((addvalue: FilterTransactionDetails) => void) | any;
  getFilteredTransaction?:
    | ((addvalue: FilterTransactionDetails, pageNumber: any) => void)
    | any;
  tsn?: string;
  type: string;
  token?: string | any;
  merchantId?: string;
  userId?: string;
  outletId?: string;
}

//const date = new Date()
const TransactionsTable: FC<TransTableProps> = ({
  data,
  getFilteredTransaction,
  tsn,
}) => {
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);
  const authApi = useSelector((state: RootState) => state.authReducer);
  const dispatch = useDispatch();
  const merchantApi: {
    merchantData: MerchantEx;
    loading: boolean;
    error: null | string;
    merch_id: string;
  } = useSelector((state: RootState) => state.merchantReducer);

  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  const { t } = useTranslation("translation", {
    keyPrefix: "softposTransaction",
  });

  // Format the dates as yyyy-MM-dd strings
  const formattedStartDate = oneMonthAgo.toISOString().split("T")[0];
  const formattedEndDate = new Date().toISOString().split("T")[0];
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [addvalues, setAddValues] = useState({
    terminalId: "",
    tsn: tsn ? tsn : "",
    RRN: "",
    operationType: [{ value: "", label: t("All") }],
    transactionType: [{ value: "", label: t("All") }],
    amountFrom: "",
    amountTo: "",
    cardType: [{ value: "", label: t("All") }],
    transactionStatus: [{ value: "", label: t("All") }],
    ReconcilationStatus: [{ value: "", label: t("All") }],
    startDate: formattedStartDate,
    endDate: formattedEndDate,
    merchantId: "",
    loggerUserId: "",
    outletId: "",
    pageSize: pageSize,
    sortBy: "trxTimestamp",
    sortDirection: "DESC",
    pageNumber: "1",
  });

  const { formatDateForTable } = useGetIntialDate();
  const themes = useContext(ThemeContext);
  const addInputProps = [
    {
      id: 0,
      name: "terminalId",
      value: addvalues.terminalId,
      type: "text",
      required: true,
      inputType: "input",
      inputLabel: t("terminalId"),
      width: "100%",
    },
    {
      id: 1,
      name: "tsn",
      value: addvalues.tsn,
      type: "text",
      required: true,
      inputType: "input",
      inputLabel: t("tsn"),
      width: "100%",
    },
    {
      id: 2,
      name: "RRN",
      value: addvalues.RRN,
      type: "text",
      required: true,
      inputType: "input",
      inputLabel: t("rrn"),
      width: "100%",
    },
    {
      id: 3,
      name: "transactionStatus",
      value: addvalues.transactionStatus,
      type: "",
      required: true,
      inputType: "select",
      inputLabel: t("status"),
      width: "100%",
      options: [
        { value: "", label: t("All") },
        { value: "Success", label: t("success") },
        { value: "Failed", label: t("failed") },
        { value: "Pending", label: t("pending") },
      ],
    },
    {
      id: 4,
      name: "amountFrom",
      value: addvalues.amountFrom,
      type: "number",
      required: true,
      inputType: "input",
      inputLabel: t("amountfrom"),
      width: "40%",
    },
    {
      id: 5,
      name: "amountTo",
      value: addvalues.amountTo,
      type: "number",
      required: true,
      inputType: "input",
      inputLabel: t("amountTo"),
      width: "40%",
    },
    {
      id: 6,
      name: "cardType",
      value: addvalues.cardType,
      type: "",
      required: true,
      inputType: "select",
      inputLabel: t("cardType"),
      width: "100%",
      options: [
        { value: "", label: t("All") },
        { value: "VC", label: t("vc") },
        { value: "MC", label: t("mc") },
        { value: "AX", label: t("ax") },
        { value: "P1", label: t("p1") },
        { value: "DM", label: t("me") },
      ],
    },
    {
      id: 7,
      name: "operationType",
      value: addvalues.operationType,
      type: "",
      required: true,
      inputType: "select",
      inputLabel: t("operationType"),
      width: "100%",
      options: [
        { value: "", label: t("All") },
        { value: "1", label: t("purchas") },
        { value: "3", label: t("cancel") },
        { value: "2", label: t("refund") },
      ],
    },
    {
      id: 8,
      name: "transactionType",
      value: addvalues.transactionType,
      type: "",
      required: true,
      inputType: "select",
      inputLabel: t("trxType"),
      width: "100%",
      options: [
        { value: "", label: t("All") },
        { value: "1", label: t("debit") },
        { value: "2", label: t("credit") },
      ],
    },
    {
      id: 9,
      name: "ReconcilationStatus",
      value: addvalues.ReconcilationStatus,
      type: "",
      required: true,
      inputType: "select",
      inputLabel: t("recStatus"),
      width: "100%",
      options: [
        { value: "", label: t("All") },
        { value: "Settled", label: t("setteld") },
        { value: "Not_Settled", label: t("notSettled") },
        { value: "Under_Processing", label: t("underrpcessinf") },
      ],
    },
  ];

  const handleAddChange = (e: any) => {
    setAddValues({ ...addvalues, [e.target.name]: e.target.value });
  };

  const downloadCsv = async () => {
    const fiterDetails = {
      ...addvalues,
      pageSize: 100000,
    };
    dispatch(
      downloadTransactionsExcel(
        authApi.token,
        fiterDetails,
        0,
        merchantApi.merch_id,
        addvalues.outletId,
        addvalues.loggerUserId,
        authApi?.partnerId,
      ),
    );
  };

  const InputAddElements = () => {
    return addInputProps.map((res) => {
      if (res.inputType === "input") {
        if (tsn) {
          if (res.name !== "tsn") {
            return (
              <ReportCustomInput
                key={res.id}
                {...res}
                onChange={handleAddChange}
              />
            );
          } else {
            return null;
          }
        } else {
          return (
            <ReportCustomInput
              key={res.id}
              {...res}
              onChange={handleAddChange}
            />
          );
        }
      } else if (res?.inputType === "select") {
        return (
          <Dropdown
            isSearchable
            isMulti
            placeHolder="Select..."
            options={res.options}
            values={res.value}
            inputLabel={res.inputLabel}
            onChange={(val: { lable: string; value: string }) => {
              /* console.log(val); */ val.value != ""
                ? setAddValues({ ...addvalues, [res.name]: val })
                : setAddValues({ ...addvalues, [res.name]: val });
            }}
            width="100%"
          />
        );
      } else {
        return null;
      }
    });
  };

  const getDateRange = (dateRange: any) => {
    setAddValues({
      ...addvalues,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
    });
  };

  useEffect(() => {
    if (addvalues.startDate != "" && addvalues.endDate != "") {
      getFilteredTransaction(addvalues, 0);
    }
  }, [addvalues.startDate, addvalues.endDate]);

  // useEffect(() => {
  //   if (addvalues.startDate != "" && addvalues.endDate != "") {
  //     getFilteredTransaction(addvalues, parseInt(addvalues.pageNumber) - 1);
  //   }
  // }, [addvalues.pageSize, addvalues.pageNumber, pageSize]);

  const columnsTransactionTable = [
    { label: t("rrn"), key: "rrn", className: "grey" },
    { label: t("tsn"), key: "tsn", className: "blue" },
    {
      label: t("trxType"),
      key: "transactionType",
      render: (data: any) => {
        const transactionType = data.transactionType;
        let ty = "";
        switch (transactionType) {
          case "1":
            ty = "Debit";
            break;
          case "2":
            ty = "Credit";
            break;
        }
        return <span>{ty}</span>;
      },
    },
    {
      label: t("operationType"),
      key: "operationType",
      render: (data: any) => {
        return handleSoftposTransactionType(
          data?.operationType,
          [t("purchas"), t("refund"), t("cancel")],
          [],
          [],
        );
      },
    },
    {
      label: t("cardType"),
      key: "cardType",
    },
    {
      label: t("status"),
      key: "trxStatus",
      render: (data: any) => {
        // return handleSoftposTransactionType(
        //   data?.status,
        //   [],
        //   [t("success"), t("pending"), t("failed")],
        //   []
        // );
        return handleSoftposTransactionType(
          data?.status,
          [],
          [t("success"), t("pending"), t("failed")],
          [],
        );
      },
    },
    /*{
      label: t("recStatus"),
      key: "reconciliationStatus",
      render: (data: any) => {
        return handleSoftposTransactionType(
          data?.reconciliationStatus,
          [],
          [],
          [t("setteld"), t("notSettled")]
        );
      },
    },*/
    {
      label: t("amount"),
      key: "amount",
      className: "mid",
      render: (data: any) =>
        handleFormateCurrency(data?.amount, themes.currencyEn1),
    },
    {
      label: t("date"),
      key: "trxTimestamp",
      render: (data: any) => {
        if (!data?.trxTimestamp) return <> - </>;
        const formattedDate = formatDateForTable(data?.trxTimestamp);
        return (
          <span className="dateWlogo">
            <Clock />
            <span className="date">{formattedDate}</span>
          </span>
        );
      },
    },
    {
      label: t("national"),
      key: "national",
      render: (data: any) => (
        <span>{data?.national ? t("true") : t("false")}</span>
      ),
    },
    {
      label: t("seeRec"),
      key: "showReceipt",
      render: (data: any) => {
        return (
          <>
            {" "}
            <Link
              to={`/transactions/Reciept?id=${btoa(`${data.trxId}`)}`}
              className="down-arrow"
            >
              <ToolTip title={t("View", { name: t("seeRec") })}>
                <OpenEyeIcon />
              </ToolTip>
            </Link>
          </>
        );
      },
    },
  ];
  return (
    <>
      <ReTable
        data={data?.transactionListDetails?.content}
        columns={columnsTransactionTable}
        currentPageProp={data?.transactionListDetails?.pageable?.offset}
        page={data?.transactionListDetails?.pageable?.pageNumber}
        resultPageLength={data?.transactionListDetails?.numberOfElements}
        totalMatches={data?.transactionListDetails?.totalElements}
        totalPages={data?.transactionListDetails?.totalPages}
        loading={data?.loading}
        isTableDetailRow={true}
        isPagination={true}
        showDateFilter={true}
        showRefreshButton={false}
        showPagination={true}
        onFilter={() => setIsComponentVisible(true)}
        pageSize={pageSize}
        onDateRangeSelect={(date) => {
          getDateRange(date);
        }}
        onPageSizeChange={(newPageSize) => {
          setAddValues({ ...addvalues, pageSize: newPageSize });
          setPageSize(newPageSize);
          setCurrentPage(newPageSize);
          getFilteredTransaction({ ...addvalues, pageSize: newPageSize }, 0);
        }}
        onPageChange={(newPage) => {
          // setAddValues({ ...addvalues, pageNumber: newPage.toString() });
          // getFilteredTransaction(addvalues, newPage - 1);
          const next = { ...addvalues, pageNumber: newPage.toString() };
          setAddValues(next);
          getFilteredTransaction(next, newPage - 1);
        }}
        error={data?.error}
        onDownloadFullData={downloadCsv}
      />
      <div className="filters" ref={ref}>
        {isComponentVisible ? (
          <FilterMenu
            menuTitle={t("filterTransactions")}
            ApplyContent={
              data?.loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                </>
              ) : (
                t("apply")
              )
            }
            closeMenu={() => {
              setIsComponentVisible(false);
            }}
            onApplyClick={() => {
              getFilteredTransaction(addvalues, 0);
            }}
          >
            <div className="search-elements ">{InputAddElements()}</div>
          </FilterMenu>
        ) : null}
      </div>
    </>
  );
};
export default TransactionsTable;
